import React, {Component} from 'react';
import styled from 'styled-components';
import {FaBook} from 'react-icons/fa';
import Header from '../components/Header';
import Get from '../components/Get';
import MoreBottomTab from '../MoreBottomTab';

const option = {
  title: 'Loading',
  message: 'Please Wait..',
  isCancelable: true,
};

export default class PostFree extends Component {
  constructor() {
    super();
    this.state = {
      rows: null,
    };
  }

  get() {
    // Show loading indicator here if needed
    Get.Wallet('withdraw')
      .then(res => {
        // Hide loading indicator here
        if (res.transection && res.transection.length > 0) {
          const flatTransactions = res.transection.flatMap(group => group.data);
          if (flatTransactions.length > 0) {
            const data = flatTransactions.map((item, key) => (
              <CardRow key={key}>
                <RowTop>
                  <GameName>{item.message}</GameName>
                  <DateText>{item.date}</DateText>
                </RowTop>
                <RowBottom>
                  <AmountText>-{item.amount}</AmountText>
                  {item.status === 'process' && (
                    <StatusText>{item.status}</StatusText>
                  )}
                </RowBottom>
              </CardRow>
            ));
            this.setState({rows: data});
          } else {
            this.setState({
              rows: <EmptyState>No Transaction Available</EmptyState>,
            });
          }
        } else {
          this.setState({
            rows: <EmptyState>No Transaction Available</EmptyState>,
          });
        }
      })
      .catch(err => {
        console.error('Withdraw Fetch Error:', err);
      });
  }

  componentDidMount() {
    this.get();
    const {navigation} = this.props;
    if (navigation && navigation.addListener) {
      this.willFocusListener = navigation.addListener('willFocus', () => {
        this.get();
      });
    }
  }

  render() {
    return (
      <Container>
        <Scroll>
          <HeaderBar>
            <HeaderTitle>Withdraw History</HeaderTitle>
          </HeaderBar>
          {this.state.rows}
          <MoreBottomTab />
        </Scroll>
      </Container>
    );
  }
}

// Styled Components

const Container = styled.div`
  background-color: #f9f9f9;
  min-height: 100vh;
`;

const Scroll = styled.div`
  padding-bottom: 20px;
`;

const HeaderBar = styled.div`
  height: 60px;
  background-color: #00318b;
  display: flex;
  justify-content: center;
  align-items: center;
  border-bottom-left-radius: 20px;
  border-bottom-right-radius: 20px;
`;

const HeaderTitle = styled.h1`
  font-size: 18px;
  font-weight: bold;
  color: #fff;
  text-align: center;
`;

const CardRow = styled.div`
  background-color: rgba(29, 185, 120, 0.41);
  margin: 8px 16px;
  padding: 16px;
  border-radius: 12px;
`;

const RowTop = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
`;

const GameName = styled.div`
  font-size: 16px;
  font-weight: bold;
  color: #333;
`;

const DateText = styled.div`
  font-size: 12px;
  color: #888;
`;

const RowBottom = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const AmountText = styled.div`
  font-size: 18px;
  font-weight: bold;
  color: #d9534f;
`;

const StatusText = styled.div`
  font-size: 12px;
  color: #ff9800;
`;

const EmptyState = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: calc(100vh - 200px);
  color: #555;
  font-size: 16px;
`;
